<template>
  <div class="goods-img">
    <el-image
      :src="img || '~@/assets/img/bitmap.png'"
      fit="cover"
      class="img"
    />
  </div>
</template>
  
<script>
export default {
  prop: {
    img: {
      type: String,
      default: "",
    },
  },
};
</script>
  
<style lang="scss" scoped>
.goods-img {
  border-radius: 16px;
  border: 2px solid #f5f6fa;
  width: 200px;
  height: 200px;
  .img {
    width: 100%;
    height: 100%;
  }
}
</style>